import {useEffect} from 'react';

const useInterval = (func, {delay = 10000} = {}) => {
  useEffect(() => {
    const interval = setInterval(func, delay);
    return () => clearInterval(interval);
  }, [func]);
};

export default useInterval;
